<template>
    <article class="message p-2 md:p-4 lg:p-6 flex flex-col w-full" :class="accordionClasses">
        <div class="message-header" @click="toggleAccordion">
            <div class="flex flex-row justify-start ">
                <button class="focus:outline-none">
                    <span class="my-auto mx-2 material-icons message-header message-icon">keyboard_arrow_up</span>
                </button>
                <h2 class="select-none">{{question}}</h2>
            </div>
        </div>
        <div class="message-body">
            <div class="message-content">
                <p class="select-none">{{answer}}</p>
            </div>
        </div>
    </article>
</template>
<script>
export default {
    props: ['question', 'answer'],
    data() {
        return {
            isOpen: false,
        }
    },
    methods: {
        toggleAccordion: function() {
            this.isOpen = !this.isOpen;
        }
    },
    computed: {
        accordionClasses: function() {
            return {
                'is-closed': !this.isOpen,
                'is-primary': this.isOpen,
                'is-dark': !this.isOpen
            };
        }
    }
}
</script>
<style scoped>

h2{
    font-family: 'Playfair Display', serif;
    font-style: italic;
    cursor: pointer;
}

p{
    font-family: 'Montserrat', serif;
}

.message {
    max-width: 500px;
    margin-left: auto;
    margin-right: auto;
    border-bottom: 1px solid theme('colors.primary');
}

.message-header {
    cursor: pointer;
}

.message-body {
    padding: 0;
    max-height: 10em;
    overflow: hidden;
    transition: 0.3s ease all;
}

.is-closed .message-body {
    max-height: 0;
}

.is-closed .message-icon {
    transform: rotate(180deg);
    transition: 0.3s ease all;
}

.message-content {
    padding: 20px;
}
</style>